module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"PageArticleListCategory":{"breadcrumbs":{"index":"Blog"},"empty":"Pro tuto kategorii zatím obsah připravujeme. Určitě ale najdete jiné zajímavé články v jiných kategoriích.","seo":{"description":"Inspirativní články {category} na {website}","keywords":"Inspirativní články {category}, {website}","title":"Inspirativní články {category}"}}}}')
  delete Component.options._Ctor
}
